import { isClient as i } from "./index599.js";
import { isIOS as s } from "./index599.js";
const t = () => i && /firefox/i.test(window.navigator.userAgent), r = () => i && /android/i.test(window.navigator.userAgent);
export {
  r as isAndroid,
  i as isClient,
  t as isFirefox,
  s as isIOS
};
